"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isApiAccount(object) {
    return checkApiAccount(object).fulfilled;
}
exports.isApiAccount = isApiAccount;
function checkApiAccount(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("id"), Check_1.hasString("userId"), Check_1.hasChoice("type", ["REGULAR"]), Check_1.hasNumber("validUntil")).withOptions(options).explain();
}
exports.checkApiAccount = checkApiAccount;
//# sourceMappingURL=ApiAccount.js.map